// Frontend client for the Pool Analyzer endpoints.
import { api } from "./api";

export const timingCurrentFpl = () =>
    api.get(`/timing/pool/current-fpl`, { timeout: 30000 }).then((r) => r.data);

export const timingPoolMatch = (items) =>
    api.post(`/timing/pool/match`, { items }, { timeout: 60000 }).then((r) => r.data);

export const timingPoolAnalyze = (players) =>
    api.post(`/timing/pool/analyze`, { players }, { timeout: 90000 }).then((r) => r.data);

export const timingPoolOptimize = (players) =>
    api.post(`/timing/pool/optimize`, { players }, { timeout: 90000 }).then((r) => r.data);

export const timingPoolSuggest = (players, topN = 10) =>
    api.post(`/timing/pool/suggest`, { players }, { params: { top_n: topN }, timeout: 120000 }).then((r) => r.data);

export const timingPoolMatrix = (players) =>
    api.post(`/timing/pool/matrix`, { players }, { timeout: 60000 }).then((r) => r.data);

export const timingPoolSimulate = (players, opts = {}) => {
    const { seed = 42, manualSquadIds = null, manualCaptainId = null,
            disableChips = false, disableWildcard = false, limitPool = null } = opts;
    const params = { seed };
    if (manualSquadIds && manualSquadIds.length) params.manual_squad_ids = manualSquadIds.join(",");
    if (manualCaptainId != null) params.manual_captain_id = manualCaptainId;
    if (disableChips) params.disable_chips = true;
    if (disableWildcard) params.disable_wildcard = true;
    if (limitPool != null) params.limit_pool = limitPool;
    return api.post(`/timing/pool/simulate`, { players }, { params, timeout: 180000 }).then((r) => r.data);
};
